import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { queryKeys } from '@/lib/query-keys';

interface ExportDownloadUrlApiResponse {
  success: boolean;
  data: { downloadUrl: string };
}

export function useExportDownloadUrl(id: number | undefined) {
  return useQuery({
    queryKey: queryKeys.exports.downloadUrl(id ?? 0),
    queryFn: async () => {
      const response = await apiClient.get<ExportDownloadUrlApiResponse>(
        `/exports/${id}/download-url`,
      );
      return response.data.data.downloadUrl;
    },
    enabled: id != null && id > 0,
    // Pre-signed S3 URLs expire — never serve a cached URL
    staleTime: 0,
  });
}
